/**
 * 全角ひらがなから半角への変換表
 */
export const katakanaMap: Record<string, string> = {
  が: 'ｶﾞ',
  ぎ: 'ｷﾞ',
  ぐ: 'ｸﾞ',
  げ: 'ｹﾞ',
  ご: 'ｺﾞ',
  ざ: 'ｻﾞ',
  じ: 'ｼﾞ',
  ず: 'ｽﾞ',
  ぜ: 'ｾﾞ',
  ぞ: 'ｿﾞ',
  だ: 'ﾀﾞ',
  ぢ: 'ﾁﾞ',
  づ: 'ﾂﾞ',
  で: 'ﾃﾞ',
  ど: 'ﾄﾞ',
  ば: 'ﾊﾞ',
  び: 'ﾋﾞ',
  ぶ: 'ﾌﾞ',
  べ: 'ﾍﾞ',
  ぼ: 'ﾎﾞ',
  ぱ: 'ﾊﾟ',
  ぴ: 'ﾋﾟ',
  ぷ: 'ﾌﾟ',
  ぺ: 'ﾍﾟ',
  ぽ: 'ﾎﾟ',
  ゔ: 'ｳﾞ',
  あ: 'ｱ',
  い: 'ｲ',
  う: 'ｳ',
  え: 'ｴ',
  お: 'ｵ',
  か: 'ｶ',
  き: 'ｷ',
  く: 'ｸ',
  け: 'ｹ',
  こ: 'ｺ',
  さ: 'ｻ',
  し: 'ｼ',
  す: 'ｽ',
  せ: 'ｾ',
  そ: 'ｿ',
  た: 'ﾀ',
  ち: 'ﾁ',
  つ: 'ﾂ',
  て: 'ﾃ',
  と: 'ﾄ',
  な: 'ﾅ',
  に: 'ﾆ',
  ぬ: 'ﾇ',
  ね: 'ﾈ',
  の: 'ﾉ',
  は: 'ﾊ',
  ひ: 'ﾋ',
  ふ: 'ﾌ',
  へ: 'ﾍ',
  ほ: 'ﾎ',
  ま: 'ﾏ',
  み: 'ﾐ',
  む: 'ﾑ',
  め: 'ﾒ',
  も: 'ﾓ',
  や: 'ﾔ',
  ゆ: 'ﾕ',
  よ: 'ﾖ',
  ら: 'ﾗ',
  り: 'ﾘ',
  る: 'ﾙ',
  れ: 'ﾚ',
  ろ: 'ﾛ',
  わ: 'ﾜ',
  を: 'ｦ',
  ん: 'ﾝ',
  ぁ: 'ｧ',
  ぃ: 'ｨ',
  ぅ: 'ｩ',
  ぇ: 'ｪ',
  ぉ: 'ｫ',
  っ: 'ｯ',
  ゃ: 'ｬ',
  ゅ: 'ｭ',
  ょ: 'ｮ',
  '。': '｡',
  '、': '､',
  'ー': 'ｰ',
  '「': '｢',
  '」': '｣',
  '・': '･',
}
